module.exports = __webpack_public_path__ + "img/6.e45894c5.png";